import { AxiosResponse } from 'axios';
import cacheableRequest from '../../../services/cacheableRequest';
import { transformSession } from '../../../services/curriculumService'; // TODO: this should be moved to a central location
import { Session, Volume } from '../../curriculum';

type GetCurriculumScheduleResponse = {
  volumes: Volume[];
  sessions: Session[];
};

export const getCurriculumSchedule = (curriculumId: string) => {
  return cacheableRequest(`/v2/org/curriculum/${curriculumId}/sessions`)
    .then((response: AxiosResponse<GetCurriculumScheduleResponse>) => response.data)
    .then(({ volumes, sessions }: GetCurriculumScheduleResponse) => ({
      volumes,
      sessions: sessions?.map(transformSession),
    }));
};
